import script from "./GbTables.vue?vue&type=script&lang=tsx"
export * from "./GbTables.vue?vue&type=script&lang=tsx"

import "./GbTables.vue?vue&type=style&index=0&id=3ee50d24&lang=css"

const __exports__ = script;

export default __exports__